import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-user-panel-detail',
  templateUrl: './user-panel-detail.component.html',
  styleUrls: ['./user-panel-detail.component.css']
})
export class UserPanelDetailComponent implements OnInit {

  breadcrumbHome: MenuItem = {}
  user: BasicUser | undefined
  indexTab: number = 0

  constructor(
    private readonly _router: Router,
    private readonly _profileService: ProfileGateway,
    private readonly translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.loadBreadcrumb()
    this.loadBasicUser()
  }

  loadBasicUser() {
    this._profileService.getBasicUser().subscribe({
      next: (v) => {
        this.user = v
      }
    })
  }

  loadBreadcrumb() {
    this.translate.get([
      'UserPages.UserPanel.PageTitle',
    ]).subscribe({
      next: (tranlations) => {
        this.breadcrumbHome = {
          label: tranlations['UserPages.UserPanel.PageTitle']
        }
      }
    })
  }

  goToContactInfoPage() {
    if (this.user?.profileType === 'Admin') {
      this._router.navigate(['/'+Routes.adminContactInfo])
    }
    else {
      this._router.navigate(['/'+Routes.userContactInfo])
    }
  }

  goToCompanyInfoPage() {
    this._router.navigate(['/'+Routes.userCompanyInfo])
  }

  goToConsigneesPage() {
    this._router.navigate(['/'+Routes.userConsignees])
  }

  goToNotifiesPage() {
    this._router.navigate(['/'+Routes.userNotifiers])
  }

  goToUserProducts() {
    this._router.navigate(['/'+Routes.userProducts])
  }

  goToUserFridgestorages() {
    this._router.navigate(['/'+Routes.userFridgestorages])
  }

  goToUserCertificates() {
    this._router.navigate(['/'+Routes.userProductCertificates])
  }

  goToSecurityOptions() {
    if (this.user?.profileType === 'Admin') {
      this._router.navigate(['/'+Routes.adminChangePassword])
    }
    else {
      this._router.navigate(['/'+Routes.userChangePassword])
    }
  }
}
